import { useEffect } from 'react';

import * as PackageJSON from '../../../../../package.json';

function BuildInfo() {
  useEffect(() => {
    console.log(`[ ${import.meta.env.MODE} | ${PackageJSON.version} ]`);
  }, []);

  return null;
}

export default BuildInfo;
